import { Button, CircularProgress, Stack } from "@mui/material";
import { updateDoc, doc } from "firebase/firestore";
import { useState } from "react";
import { toast } from "react-toastify";
import TopTitleFormComponent from "./TopTitleFormComponent";
import { db } from "../../firebase";
import DropDownComponentSorted from "../DropDownComponentSorted";

export default function EditRole(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [selectedRole, setSelectedRole] = useState(props.roleUser);

  const handleRoleChange = (v) => {
    setSelectedRole(v?.target?.value ?? v);
  };

  const handleSave = async () => {
    setIsLoading(true);
    try {
      await updateDoc(doc(db, "roles", props.userId), { role: selectedRole });
      toast.success("Role updated successfully!");
    } catch (error) {
      console.error(error);
      toast.error("An error occurred while updating the role.");
    }
    setIsLoading(false);
    props.closemodal();
  };

  return (
    <>
      <div style={{ marginTop: 4, minHeight: 160 }}>
        <div
          className="tab-form-container-centered"
          style={{ padding: "8px 0" }}
        >
          <DropDownComponentSorted
            api="roles"
            title="User role"
            value={selectedRole}
            onChange={handleRoleChange}
          />
        </div>

        <Stack direction="row" justifyContent="flex-end" spacing={1}>
          <Button
            onClick={props.closemodal}
            disabled={isLoading}
            variant="outlined"
          >
            Cancel
          </Button>
          <Button
            variant="contained"
            color="primary"
            onClick={handleSave}
            disabled={isLoading}
          >
            {isLoading ? <CircularProgress size={18} /> : "Save"}
          </Button>
        </Stack>
      </div>
    </>
  );
}
